import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import heroImg from '../Images/about-hero.webp'

const PrivacyPolicy=()=>{
     useEffect(() => {
            document.title =
              "Privacy Policy | LDL Settlement Services";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Learn how LDL Settlement Services collects, stores, and protects your personal information and privacy."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://ldlsettlementservices.com.au/privacy-policy");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Privacy Policy | LDL Settlement Services"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Learn how LDL Settlement Services collects, stores, and protects your personal information and privacy."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/privacy-policy");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/home-img.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Privacy Policy | LDL Settlement Services"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Learn how LDL Settlement Services collects, stores, and protects your personal information and privacy."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/home-img.webp"
            );
          }
          }, []);

 const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.08,
      },
    },
  };

  // PREMIUM FADE UP
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 38,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };
        
    return(
        <>
         {/**HEADER */}
         <Header
        showBreadcrumb={true}
        pageName="Privacy Policy"
      />

       {/**HERO SECTION */}
       <BreadcrumbMain
      subTitle="PRIVACY POLICY"
      title="Your Privacy Matters To Us"
      description="At LDL Settlement Services, we are committed to protecting your personal information and ensuring your data is handled securely, responsibly, and transparently throughout every stage of your property transaction."
      image={heroImg}
      showIcons={false}
    />

    {/**PRIVACY POLICY SECTION */}
   <motion.section
        className="privacy-section container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.04,
        }}
      >

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          We collect information
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We use technologies like cookies (small files stored by your
          browser), web beacons, or unique device identifiers to anonymously
          identify your computer or device so We can deliver a better
          experience. Our systems also log information like your browser,
          operating system and IP address.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We use Your Personal data to provide and improve the Service. By
          using the Service, You agree to the collection and use of
          information in accordance with this Privacy Policy.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We also knowingly contact or collect personal information from
          children under 13. If you believe we have inadvertently collected
          such information, please contact us so we can promptly obtain
          parental consent or remove the information.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Our service does not currently recognize the “Do Not Track” signal
          that may be available in some web browsers.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          Interpretation and Definitions
        </motion.h2>

        <motion.h3
          className="card-heading"
          variants={fadeUp}
        >
          Interpretation
        </motion.h3>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          The following definitions shall have the same meaning regardless of
          whether they appear in singular or in plural.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          How we collect Personally identifiable information
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          When you register we may collect a variety of information, including
          your name, mailing address, email address.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We may use cookies to identify that you’ve logged in to the
          Services. Although most browsers automatically accept cookies, you
          can change your browser options to stop automatically accepting
          cookies or to prompt you before accepting cookies.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          How we use your Personally identifiable information
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          The personal information we collect allows us to keep you posted on
          LDL Settlement Services latest Services and updates.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We also use personal information to help us develop, deliver, and
          improve our Services. From time to time, we may use your Personally
          identifiable information to send important notices and updates.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          We may collect and share anonymous location data.
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          To customize our service for you, we and our partners may collect,
          use, and share precise location data in anonymous form that does not
          personally identify you.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          You can request to see your personal data.
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We do not permit direct association with any specific individual.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          We keep personal data for a limited period.
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We do store any of your personal information on our server also But
          Google Game service can collect your personal information.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          We don’t share your personal data with other companies.
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We do not store any of your personal information
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          You can ask privacy questions.
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          If you have any questions or concerns about our privacy policies,
          please contact
          <a href="mailto:admin@ldlsettlementservices.com.au">
            {" "}admin@ldlsettlementservices.com.au
          </a>
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          Service providers access data on our behalf.
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          In order to serve you, we may share your personal and anonymous
          information with vendors and contractors strictly for operational
          purposes.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          Google Analytics
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Google Analytics is a web analytics tool that helps website owners
          understand how visitors engage with their website anonymously.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          We take steps to protect personal information
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Information we collect may be stored or processed on computers
          located in any country where we do business.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          Special situations may require disclosure of your data.
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          We may disclose information where required by law or where necessary
          to protect our legal rights, operations, and users.
        </motion.p>

        <motion.h2
          className="section-heading"
          variants={fadeUp}
        >
          You can review more privacy-related information.
        </motion.h2>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Our privacy policy may change from time to time. If we make any
          material changes, we will place a prominent notice on our website.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          Contact Us or email Us at
          <a href="mailto:admin@ldlsettlementservices.com.au">
            {" "}admin@ldlsettlementservices.com.au
          </a>
          {" "}for any query regarding privacy policy.
        </motion.p>

        <motion.p
          className="section-text"
          variants={fadeUp}
        >
          © 2026 – LDL Settlements
        </motion.p>

      </motion.section>
        </>
    )
}
export default PrivacyPolicy;